/**
 * Opens a print-friendly window with the payment breakdown content.
 * @param {Object} breakdown - { paymentId, paidAt, pharmacyName, transactionId, totalPaAmount, orders }
 * @param {{ formatDate: (d) => string, formatCurrency: (n) => string, showPharmacy?: boolean }} options
 */
export function printPaymentBreakdown(breakdown, options = {}) {
  const { formatDate, formatCurrency, showPharmacy = true } = options
  if (!breakdown) return

  const dateStr = breakdown.paidAt ? formatDate(breakdown.paidAt) : '-'
  const totalStr = formatCurrency(breakdown.totalPaAmount)
  const orders = breakdown.orders || []

  const rowsHtml = orders
    .map(
      (r) =>
        `<tr>
          <td>${r.supplierInvoiceNo ?? '-'}</td>
          <td>${r.createdAt ? formatDate(r.createdAt) : '-'}</td>
          <td>${formatCurrency(r.confirmedExtendTotal ?? 0)}</td>
          <td>${formatCurrency(r.confirmedPaValue ?? 0)}</td>
        </tr>`
    )
    .join('')

  const pharmacyRow =
    showPharmacy && breakdown.pharmacyName
      ? `<p><strong>Pharmacy:</strong> ${breakdown.pharmacyName}</p>`
      : ''

  const html = `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <title>Payment #${breakdown.paymentId} – Breakdown</title>
  <style>
    body { font-family: Arial, sans-serif; padding: 20px; max-width: 700px; margin: 0 auto; }
    h1 { font-size: 1.25rem; margin-bottom: 1rem; }
    p { margin: 0.4rem 0; }
    table { width: 100%; border-collapse: collapse; margin-top: 1rem; }
    th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
    th { background: #f5f5f5; }
    .meta { margin-bottom: 1rem; }
  </style>
</head>
<body>
  <h1>Payment #${breakdown.paymentId} – Breakdown</h1>
  <div class="meta">
    <p><strong>Payment ID:</strong> ${breakdown.paymentId}</p>
    <p><strong>Date:</strong> ${dateStr}</p>
    ${pharmacyRow}
    <p><strong>Transaction / Cheque:</strong> ${
      breakdown.transactionId != null && String(breakdown.transactionId).trim() !== '' && String(breakdown.transactionId).trim() !== '-'
        ? String(breakdown.transactionId).trim()
        : 'n/a'
    }</p>
    <p><strong>Total amount:</strong> ${totalStr}</p>
  </div>
  <h2 style="font-size: 1rem;">Orders included</h2>
  <table>
    <thead>
      <tr>
        <th>Order No.</th>
        <th>Date</th>
        <th>Confirmed value</th>
        <th>PA amount</th>
      </tr>
    </thead>
    <tbody>${rowsHtml}</tbody>
  </table>
</body>
</html>`

  const win = window.open('', '_blank')
  if (!win) {
    console.warn('Popup blocked – please allow popups to print.')
    return
  }
  win.document.write(html)
  win.document.close()
  win.focus()
  setTimeout(() => {
    win.print()
    // Close after print dialog is done (user can cancel; we close after a delay)
    setTimeout(() => win.close(), 1000)
  }, 300)
}
